<template>
  <div id="app">
    <div class="app-main">
      <slot />
    </div>
    <preview-resource
      v-if="ctrl.show"
      :id="ctrl.id"
      :model-value="ctrl.show"
      @close="ctrl.show = false"
    />
    <back-top />
    <suspense-box />
    <message-box />
  </div>
</template>

<script setup>
import cookie from '@/utils/cookies'
import { useUserStore } from '../stores/user'
import { setStore } from '../utils/storage'
import previewResource from '@/components/previewResource.vue'
const route = useRoute()
const { getShopInfo, getUserView } = useUserStore()
getShopInfo()
const cookieData = cookie.getShop()
useHead({
  link: [
    { rel: 'icon', type: 'image/x-icon', href: cookieData.shopIcon },
    { rel: 'stylesheet', type: 'text/css', href: '//live-cdn.baijiayun.com/www-video-jssdk/dep/videojs/0.0.6/dist/videojs.css' }
  ],
  script: [
    { src: '//lib.baomitu.com/jquery/3.5.1/jquery.min.js' },
    { src: 'https://www.baijiayun.com/bplayer/1.10.68/bplayer.js' },
    { src: 'https://www.baijiayun.com/bplayer/1.10.68/dep/ffplayer.js' },
    { src: '//player.polyv.net/script/player.js' }
  ]
})
const ctrl = reactive({
  show: false,
  id: ''
})
onMounted(() => {
  // 入学诊断为游客短信校验流程，不强制拉取登录用户信息，避免过期 token 跳登录页
  if (!route.path.startsWith('/entrancetest')) {
    getUserView()
  }
  setStore('bjyDefinition', '720p')
  
  // 考试页面媒体播放器触发逻辑
  document.addEventListener('click', (e) => {
    if (e && e.target) {
      let target = e.target;
      // 向上查找最多3层来寻找data-id属性
      for (let i = 0; i < 3 && target; i++) {
        if (target.dataset && target.dataset.id) {
          ctrl.id = target.dataset.id
          ctrl.show = true
          e.preventDefault()
          e.stopPropagation()
          return
        }
        target = target.parentElement
      }
    }
  })
})
</script>
<style>
@import url('@/assets/font/iconfont.css');
</style>
<style lang="scss" scoped>
#app {
  position: relative;
  background-color: #f6f8fb;
}
.app-main {
  height: 100vh;
  background-color: #f6f8fb;
  overflow: auto;
  padding-top: 0;
  padding-bottom: 0;
}
.app_container{
  padding-bottom: 0 !important;
}
</style> 